import { Logo } from "./Logo";
import { Navigation } from "./Navigation";
import { Container } from "./style";

export const Header = ({ homeNavOnly }) => {
  return (
    <Container>
      <Navigation homeNavOnly={homeNavOnly} />
      <Logo />
    </Container>
  );
};
